import styled from "styled-components";
import theme from "../../Styles/theme";


export const Container = styled.div`
    
border-radius: 0.25rem;
`;

export const DivX = styled.div`
    text-align: right;
`;

export const HandleInput = styled.div`

    display: flex;
    align-items: center;
    justify-content:space-around;
`;



export const HandleButton = styled.div`
    margin:auto;
    margin-top:2vh;
    width:50%;
`;